import {  useRef } from "react";
import createPostMessageService from "../../postMessageService";

const usePostMessageConfig = () => {
	const storeRef = useRef(createPostMessageService());

	return {
		...storeRef.current,
		controls: adaptPanRotate(storeRef.current.controls),
	};
};

export default usePostMessageConfig;

// panRotate is deprecated. we split it into "pan" and "rotate"
const adaptPanRotate = (controls = {}) => ({
	...controls,
	pan: controls.pan || controls.panRotate,
	rotate: controls.rotate || controls.panRotate,
	panRotate: undefined,
});
